<template>
  <template v-if="typeof props.dataValue === 'string'">
    <el-switch v-model="refValue" :active-value="'true'" :inactive-value="'false'"/>
  </template>
  <template v-else>
    <el-switch v-model="refValue" />
  </template>
</template>

<script setup lang="ts">
import { ref, defineProps, onMounted } from 'vue'

const props = defineProps({
  dataValue: {
    required: true
  }
})

const refValue = ref(false)

onMounted(async () => {
  refValue.value = props.dataValue
})
</script>
